import GroupTransferRulePanel from "./groupTransferRulePanel.container";

export default GroupTransferRulePanel;
